/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: 'ap-southeast-1',
  aws_cloud_logic_custom: [
    {
      name: 'AdminQueries',
      endpoint:
        'https://wrqqqpdw4f.execute-api.ap-southeast-1.amazonaws.com/vpmain',
      region: 'ap-southeast-1',
    },
    {
      name: 'record',
      endpoint:
        'https://t0p721wx02.execute-api.ap-southeast-1.amazonaws.com/vpmain',
      region: 'ap-southeast-1',
    },
  ],
  aws_appsync_graphqlEndpoint:
    'https://wlccwkpdeze6zk4ker5xejt5l4.appsync-api.ap-southeast-1.amazonaws.com/graphql',
  aws_appsync_region: 'ap-southeast-1',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_appsync_apiKey: 'da2-rokediz3pzbuvhqy2mssinbp2y',
  aws_cognito_identity_pool_id:
    'ap-southeast-1:220368f1-7687-4b28-a7b8-533e8ababcdc',
  aws_cognito_region: 'ap-southeast-1',
  aws_user_pools_id: 'ap-southeast-1_6jVcpLbaI',
  aws_user_pools_web_client_id: '195evegnaa7nehln3o1cotcnjf',
  oauth: {},
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ['PHONE_NUMBER'],
};

export default awsmobile;
